import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Phone, Mail, MessageCircle } from 'lucide-react';
import { useSiteSettings } from '@/contexts/SiteSettingsContext';

const ContactPage = () => {
  const { settings } = useSiteSettings();
  const s = settings || {};
  const whatsapp = s.whatsapp || '85295858258';
  const phone = s.phone || '9585 8258';
  const phoneTel = phone.replace(/\s+/g, '');
  const phoneTelLink = phoneTel.startsWith('+') ? phoneTel : `+852${phoneTel}`;
  const email = s.email || 'contact.wisedriving@gmail.com';
  const heroTitle = s.contact_hero_title || '聯絡我們';
  const heroSubtitle = s.contact_hero_subtitle || '有任何問題或需要查詢課程？歡迎隨時聯絡我們';

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <section className="relative overflow-hidden bg-gradient-to-br from-blue-600 via-blue-500 to-blue-700 py-20 md:py-28">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-72 h-72 bg-white rounded-full blur-3xl" />
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-yellow-300 rounded-full blur-3xl" />
        </div>
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-5 tracking-tight">
            {heroTitle}
          </h1>
          <p className="text-lg md:text-xl text-blue-100 leading-relaxed max-w-2xl mx-auto">
            {heroSubtitle}
          </p>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* WhatsApp CTA */}
          <Card className="overflow-hidden border-0 shadow-xl bg-white mb-8">
            <div className="h-2 bg-gradient-to-r from-green-400 to-green-600" />
            <CardContent className="p-8 md:p-12 text-center">
              <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6">
                <MessageCircle className="h-10 w-10 text-green-600" />
              </div>
              <h2 className="text-3xl font-bold mb-3">透過 WhatsApp 聯絡我們</h2>
              <p className="text-lg text-muted-foreground mb-8 max-w-xl mx-auto">
                點擊下方按鈕即可直接開啟 WhatsApp 對話，我們會盡快回覆您
              </p>
              <Button
                asChild
                size="lg"
                className="rounded-full bg-green-500 hover:bg-green-600 text-white px-12 h-14 text-lg"
              >
                <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noopener noreferrer">
                  <MessageCircle className="mr-2 h-6 w-6" />
                  WhatsApp 即時查詢
                </a>
              </Button>
            </CardContent>
          </Card>

          {/* Other Contact Info */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <Card className="border-0 shadow-md">
              <CardContent className="p-6">
                <div className="flex gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center">
                      <Phone className="h-6 w-6 text-blue-600" />
                    </div>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">電話</h3>
                    <a
                      href={`tel:${phoneTelLink}`}
                      className="text-lg font-medium text-blue-600 hover:underline"
                    >
                      {phone}
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-0 shadow-md">
              <CardContent className="p-6">
                <div className="flex gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center">
                      <Mail className="h-6 w-6 text-blue-600" />
                    </div>
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">電子郵件</h3>
                    <a
                      href={`mailto:${email}`}
                      className="text-blue-600 hover:underline break-all"
                    >
                      {email}
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
